import { render, staticRenderFns } from "./Katalozi.vue?vue&type=template&id=0e5c74b9&scoped=true"
import script from "./Katalozi.vue?vue&type=script&lang=js"
export * from "./Katalozi.vue?vue&type=script&lang=js"
import style0 from "./Katalozi.vue?vue&type=style&index=0&id=0e5c74b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c74b9",
  null
  
)

export default component.exports